import type {
  DemandCurrentSource,
  LimitBasis,
  LimitComparison,
} from "../services/powerQualityContract";
import type { ValidationLabels } from "../utils/validationMessages";

// On-screen labels of the harmonic assessment form (EOS-11b, A32), keyed by the request path
// under the "study" prefix of the run request; the loads are a list, so their fields carry
// "loads.*" and the list's singular name is "Load".
export const HARMONICS_LABELS: ValidationLabels = {
  fields: {
    "study.code": "Study code",
    "study.name": "Study name",
    "study.bus_code": "Bus code (point of common coupling)",
    "study.system_nominal_voltage_v": "System nominal voltage (V)",
    "study.frequency_hz": "Frequency (Hz)",
    "study.loads": "Distorting loads",
    "study.loads.*.code": "Load code",
    "study.loads.*.fundamental_current_a": "Fundamental current I1 (A)",
    "study.loads.*.spectrum": "Harmonic spectrum",
    "study.loads.*.spectrum.*.order": "Harmonic order",
    "study.loads.*.spectrum.*.current_a": "Harmonic current (A)",
    "study.loads.*.spectrum.*.percent_of_fundamental": "Harmonic current (% of I1)",
    "study.loads.*.spectrum_source": "Spectrum source",
    "study.loads.*.spectrum_source_date": "Spectrum source date",
    "study.load_run_id": "Load run",
    "study.typed_demand": "Demand current source",
    "study.typed_demand.maximum_demand_current_a": "Maximum demand current IL (A)",
    "study.typed_demand.source": "Demand current source text",
    "study.fault_run_id": "Fault run",
    "study.typed_short_circuit_power": "Short-circuit power source",
    "study.typed_short_circuit_power.short_circuit_power_kva": "Short-circuit power S_sc (kVA)",
    "study.typed_short_circuit_power.source": "Short-circuit power source text",
    "study.declared_limit": "Declared harmonic limit",
    "study.declared_limit.thdv_percent": "Declared THDv limit (%)",
    "study.declared_limit.tdd_percent": "Declared TDD limit (%)",
    "study.declared_limit.source": "Limit source",
    "study.jurisdiction_profile": "Jurisdiction profile",
    notes: "Study notes",
  },
  groups: { loads: "Load", spectrum: "Harmonic" },
};

export const DEMAND_SOURCE_LABELS: Record<DemandCurrentSource, string> = {
  LINKED_LOAD_RUN: "Linked load run",
  TYPED: "Typed value",
};

export const LIMIT_BASIS_LABELS: Record<LimitBasis, string> = {
  REGISTER_VERIFIED: "Verified register table",
  DECLARED: "Declared by the engineer (not verified)",
  NOT_ESTABLISHED: "Not established",
};

export const COMPARISON_LABELS: Record<LimitComparison, string> = {
  WITHIN: "Within the limit",
  ABOVE: "Above the limit",
  NOT_EVALUATED: "Not evaluated",
};
